module.exports = "/images/MIL_portada.jpg?316d7693045c4c02b118c7bdcdcb8de6";